import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import MenuState from "./store/state/MenuState";
import { store } from "./store/store";
import { BrowserRouter, Routes } from "react-router-dom";
import { AccessProvider } from "./context/AccessContext";
import { identifyClarityFromStorage } from "./helpers/clarity";
import { identifyPostHogFromStorage } from "./helpers/posthog";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// Prefer env vars (.env is not committed); fall back to the known project
// values so analytics still works in builds/environments without the .env file.
const POSTHOG_KEY =
  process.env.REACT_APP_PUBLIC_POSTHOG_KEY ||
  "phc_x2cnZxRAGDEbFskE94v28fwQXZdLNEk4Hw7gtEehqJWy";
const POSTHOG_HOST =
  process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  capture_pageview: false,
  capture_pageleave: true,
  // Session replay ON. Keep it explicit so it can't be toggled off by accident.
  disable_session_recording: false,
  session_recording: {
    // Dashboards app: we WANT to see which filters/dates/tabs users click, so
    // don't blanket-mask inputs. Still mask password-type fields (login OTP),
    // and any element explicitly tagged with the `ph-no-capture` class.
    maskAllInputs: false,
    maskInputOptions: { password: true },
  },
});

// Re-tag Clarity + PostHog for users whose session is restored from localStorage
// (i.e. they don't pass through the login flow on this load).
identifyClarityFromStorage();
identifyPostHogFromStorage();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <PostHogProvider client={posthog}>
    <Provider store={store}>
      <BrowserRouter>
        <AccessProvider>
          <App />
        </AccessProvider>
      </BrowserRouter>
    </Provider>
  </PostHogProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
